export const sortPlansByDisplayOrder = (plansList = []) => {
	if (!Array.isArray(plansList)) return [];

	return [...plansList].sort((a, b) => {
		const orderA = Number(a?.display_order ?? a?.meta?.display_order ?? 0);
		const orderB = Number(b?.display_order ?? b?.meta?.display_order ?? 0);

		if (orderA !== orderB) {
			return orderA - orderB;
		}

		const nameA = String(a?.name ?? a?.title ?? '');
		const nameB = String(b?.name ?? b?.title ?? '');
		return nameA.localeCompare(nameB, undefined, { sensitivity: 'base' });
	});
};

export default sortPlansByDisplayOrder;
